import { render, staticRenderFns } from "./rgtpList.vue?vue&type=template&id=fe8bcf5e&scoped=true&"
import script from "./rgtpList.vue?vue&type=script&lang=js&"
export * from "./rgtpList.vue?vue&type=script&lang=js&"
import style0 from "./rgtpList.vue?vue&type=style&index=0&id=fe8bcf5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8bcf5e",
  null
  
)

export default component.exports